import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CfetBaseComponent, ErrorService } from '../../../cfet-core';
import { SheerIdApiIntegrationPayload } from 'src/app/interface-models/sheer-id-api-interface';
import { SheeridApiService } from 'src/app/cfet-core/core-services/sheeridapiservice.service';
import { CFETILMSheerIdApiConstant } from 'src/app/cfet-core/constants/cfet-ilm-sheerid-api.constant';

@Component({
    selector: 'app-customer-documents-upload-utf',
    templateUrl: './customer-documents-upload-utf.component.html',
    styleUrls: ['./customer-documents-upload-utf.component.scss'],
    standalone: false
})

export class CustomerDocumentsUploadUtfComponent extends CfetBaseComponent implements OnInit {
  public openModal = '';
  showIDAccordion = true;
  showPayAccordion = true;
  showCertAccordion = true;
  showSignedAccordion = true;
  showUploadButton = true;
  disabledUploadingButton = false;
  disableSkipButton = false;
  showDoneButton = false;
  openDocUploadModal = '';
  openFileDeleteModal = '';
  openSkipFileUploadModal = '';
  OpenEmployeeBadge = false;
  OpenEmployeePay = false;
  open101Card = false;
  OpenCertification = false;
  OpenSignedLetter = false;
  isEmpVolID = false;
  isEmpPay = false;
  isCert = false;
  isSignedLetter = false;
  accModalClicked = false;
  deleteModalClicked = false;
  skipModalClicked = false;
  selectedOrg: any;
  fileName: string;
  fileSizeError = false;
  fileExtnError = false;
  fileUpload = true;
  fileUploaded = false;
  file: File;
  fileList = [];
  imagePath: any[];
  localUrl: any[];
  url: any;
  currentStepData: any;
  fileNameSplit: any;
  splitFileName: any;
  getFileExt: any;
  ind: any;
  selectedFile: any;
  validfiletype: boolean;
  errorMessage: any;
  geteligibilityInfo: any;
  entity: any;
  type: any;
  jobfunction: any;
  docsAllowed: any;
  hideDocuploadSection = false;
  openCancelModal = '';
  showCancelModal = false;
  userFacing = true;
  agentFacingDesc = true;
  mobileView = false;
  show101CardAccordion = false;

  @Input() selectedWorkPlace: string;
  @Input() fname: string;
  @Input() lname: string;
  @Input() selectedCategory: string;
  @Input() workDept:string;
  @ViewChild('attachments') attachment: any;
  @Output() goToDocReceived = new EventEmitter<any>();
  @Input() programId: any;

  constructor(private errorService: ErrorService, 
    private readonly sheeridApiService: SheeridApiService) { super(); }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.errorService.showError.next(false);
    if (sessionStorage.getItem('ngStorage-currentStepData')) {
      this.currentStepData = JSON.parse(sessionStorage.getItem('ngStorage-currentStepData'));
    }
    if (sessionStorage.getItem('eligibilityInfo') && Object.keys(sessionStorage.getItem('eligibilityInfo')).length !== 0) {
      this.geteligibilityInfo = JSON.parse(sessionStorage.getItem('eligibilityInfo'));
      this.entity = this.geteligibilityInfo.entity;
      this.type = this.geteligibilityInfo.type;
      this.jobfunction = this.geteligibilityInfo.selectedRole;
      this.docsAllowed = this.geteligibilityInfo.documents;
      // id-badge,paystub,signedletter,emscert
      this.showIDAccordion = this.docsAllowed && this.docsAllowed.indexOf('id-badge') > -1;
      this.showPayAccordion = this.docsAllowed && this.docsAllowed.indexOf('paystub') > -1;
      this.showSignedAccordion = this.docsAllowed && this.docsAllowed.indexOf('signedletter') > -1;
      this.showCertAccordion = this.docsAllowed && this.docsAllowed.indexOf('emscert') > -1;
      this.show101CardAccordion = this.docsAllowed && this.docsAllowed.indexOf('101 Card') > -1;

      if (this.docsAllowed === undefined || this.docsAllowed.length === 0) {
        this.showIDAccordion = true;
        this.showPayAccordion = true;
        this.showSignedAccordion = true;
        this.showCertAccordion = true;
        this.show101CardAccordion = true;
      }
    }
  }

  elementInViewport(el) {
    const elinfo = {
      'top': el.offsetTop,
      'height': el.offsetHeight,
    };
    if (elinfo.top + elinfo.height < window.screenY || elinfo.top > window.screenY + window.innerHeight) {
      return false;
    } else {
      return true;
    }
  }

  onFileChange(event: any): void {
    if (event.target.files && event.target.files.length > 0) {
      this.showUploadButton = false;
      this.disableSkipButton = true;
      this.openSkipFileUploadModal = 'close';
      this.file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (fileEvent: any) => {
        this.url = fileEvent.target.result;
      };
      reader.readAsDataURL(this.file);
      // Delay the file upload process
      setTimeout(() => {
        if (this.file) {
          this.fileList.push({
            'file': this.file, 'imageurl': this.url
          });
          this.fileUploaded = true;
          this.fileUpload = false;
          this.showUploadButton = true;
          this.showDoneButton = true;
          this.fileName = this.file.name;
          if (this.fileList.length > 2) {
            this.showUploadButton = false;
          }
        }
      }, 500);
    }
    this.attachment.nativeElement.value = '';
  }

  removeSelectedFile(index: any, event: any, fileName) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.ind = index;
      this.selectedFile = fileName;
      this.openFileDeleteModal = 'open';
      this.deleteModalClicked = true;
    }
  }

  skipUpload(event: any) {
    if ((event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) && !this.disableSkipButton) {
      this.openSkipFileUploadModal = 'open';
      this.skipModalClicked = true;
    }
  }

  cancelCreation(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal = true;
      this.openCancelModal = 'open';
    }
  }

  closeModal(event) {
    if (event === 'modalClose') {
      this.openCancelModal = 'close';
    }
  }
  closeDeleteFileModal(event) {
    if (event === 'modalClose') {
      this.openFileDeleteModal = 'close';
    } else if (event === 'DeleteFile') {
      if (this.ind !== -1) {
        this.fileList.splice(this.ind, 1);
        if (this.fileList.length < 3) {
          this.showUploadButton = true;
        }
      }
    }
    // If all the files are removed
    if (this.fileList.length === 0) {
      this.fileUploaded = false;
      this.fileUpload = true;
      this.showUploadButton = true;
      this.showDoneButton = false;
      this.disableSkipButton = false;
    }
  }

  closeSkipFileUploadModal(event) {
    if (event === 'modalClose') {
      this.openSkipFileUploadModal = 'close';
    }
  }

  removeError() {
    this.errorService.showError.next(false);
  }

  checkValidFileTypeExist() {
    for (const element of this.fileList) {
      // To check whether the file is all these format or not or not
      this.fileNameSplit = element.file.name;
      this.splitFileName = element.file.name.substr((this.fileNameSplit.lastIndexOf('.') + 1));
      this.getFileExt = this.splitFileName.toLowerCase();
      if ((this.getFileExt === 'pdf' || this.getFileExt === 'png' || this.getFileExt === 'jpg' ||
        this.getFileExt === 'jpeg' || this.getFileExt === 'gif' || this.getFileExt === 'bmp')
        && (Math.floor(element.file.size / 1000) < 10000)) {
        this.validfiletype = true;
      } else {
        this.validfiletype = false;
        break;
      }
    }
  }

  done(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      sessionStorage.setItem('skipDocUpload',"false");
      // To spilt the filename
      this.checkValidFileTypeExist();
      if (this.validfiletype) {
        this.emitGoToDocReceived();
      } else {
        // show File Type Error
        // a page level invalid file type error message should be shown
        const messageArray = [];
        messageArray.push(this.cfetMessages.off_doc_file_error, this.cfetMessages.off_doc_file_error_desc);
        this.errorService.displayErrorMessageList(messageArray);
        // empty the list
        this.fileList = [];
        this.fileUploaded = false;
        this.fileUpload = true;
        this.showUploadButton = true;
        this.showDoneButton = false;
        this.disableSkipButton = false;
        window.scrollTo(0, 0);
      }
    }
  }

  emitGoToDocReceived() {
    if (this.currentStepData && this.currentStepData.currentStep === 'docUpload') {
      let currentStepData = this.currentStepData;
      const docUploadurl = this.currentStepData.submissionUrl;
      const docUploadxhr = new XMLHttpRequest();
      const docUploadrequestParam = new FormData();
      for (const element of this.fileList) {
        docUploadrequestParam.append('file', element.file);
      }
      docUploadxhr.open('POST', docUploadurl);
      docUploadxhr.send(docUploadrequestParam);
      this.onReadyStateChange(docUploadxhr, currentStepData);
    } else if (this.currentStepData && this.currentStepData.currentStep === 'pending') {
      // To make the session data to null
      this.currentStepData = {};
      sessionStorage.setItem('ngStorage-currentStepData', JSON.stringify(this.currentStepData));
      this.goToDocReceived.emit(true);
    }
  }

  onReadyStateChange(docUploadxhr: XMLHttpRequest, currentStepData: any) {
    let docuploadresponse: any;
    docUploadxhr.onreadystatechange = function () {
      const userProfile = JSON.parse(sessionStorage.getItem('ngStorage-savedData'));
      const sheerIdApiIntegrationData = sessionStorage.getItem('sheerIdApiIntegrationData') ? JSON.parse(sessionStorage.getItem('sheerIdApiIntegrationData')) : null;
      if (docUploadxhr.response && docUploadxhr.readyState === 4 && docUploadxhr.status === 200) {
        // To execute if there is no error - Show confirmation page
        docuploadresponse = JSON.parse(docUploadxhr.response);
        currentStepData.currentStep = docuploadresponse.currentStep;
        if (sheerIdApiIntegrationData) {
        const sheerIdApiPayload: SheerIdApiIntegrationPayload = {
        isActive: 'TRUE',
        company_user_id: sheerIdApiIntegrationData?.company_user_id,
        company_id: 21,
        userid: sheerIdApiIntegrationData?.userid,
        completedDate: docuploadresponse?.currentStep === CFETILMSheerIdApiConstant.success ? 
         this.sheeridApiService.getCurrentETTime() : null,
              verification: {
                process: CFETILMSheerIdApiConstant.processName,
                phase: {
                  name: docuploadresponse?.currentStep === CFETILMSheerIdApiConstant.pending ? 
                  CFETILMSheerIdApiConstant.ILMDocUpload : CFETILMSheerIdApiConstant.success
                },
                step: docuploadresponse?.currentStep === CFETILMSheerIdApiConstant.pending ? 
                CFETILMSheerIdApiConstant.reviewDocuments : CFETILMSheerIdApiConstant.verificationSuccess,
                status: docuploadresponse.currentStep === CFETILMSheerIdApiConstant.success ?  CFETILMSheerIdApiConstant.completed : 
                CFETILMSheerIdApiConstant.pending
              },
              sheerId: {
                programId: this.programId,
                verificationId: this.currentStepData.verificationId,
                status: docuploadresponse?.currentStep,
                successDate: docuploadresponse?.currentStep === CFETILMSheerIdApiConstant.success ? 
                this.sheeridApiService.getCurrentETTime() : null
              },
              trigger : {
                source: CFETILMSheerIdApiConstant.source
              }
            };
              this.sheeridApiService.sendSheerIdApiIntegrationData(
                sheerIdApiPayload).subscribe((response: any) => {
                console.log('SheerId API integration response:', response);
              }, (error: any) => {
                console.error('SheerId API integration error:', error);
              });
            }
        if (docuploadresponse.errorIds && docuploadresponse.errorIds.length > 0) {
          this.errorMessage = docuploadresponse.errorIds[0];
        }
        // To make the session data to null
        currentStepData = {};
        sessionStorage.setItem('ngStorage-currentStepData', JSON.stringify(currentStepData));
        if (docuploadresponse.errorIds && docuploadresponse.errorIds.length > 0) {
          this.errorMessage = docuploadresponse.errorIds[0];
        } else {
              this.goToDocReceived.emit(true);
        }
      } else if (docUploadxhr.readyState === 2 && docUploadxhr.status !== 200) {
        let errorListResponse: { errorDescription: string }[] = [];
        docuploadresponse = JSON.parse(docUploadxhr.response);
        if (docuploadresponse.errorIds && docuploadresponse.errorIds.length > 0) {
          errorListResponse = docuploadresponse?.errorIds?.map((error) => {
            return { errorDescription: error };
          });
        }
        if (sheerIdApiIntegrationData) {
        const sheerIdApiPayload: SheerIdApiIntegrationPayload = {
          isActive: 'TRUE',
          company_user_id: sheerIdApiIntegrationData?.company_user_id,
          userid: sheerIdApiIntegrationData?.userid,
          company_id: 21,
          verification: {
            process: CFETILMSheerIdApiConstant.processName,
                phase: {
                  name: CFETILMSheerIdApiConstant.ILMDocUpload
                },
                step: CFETILMSheerIdApiConstant.submit_documents_error
              },
              sheerId: {
                programId: this.programId,
                verificationId: this.currentStepData?.verificationId,
                status: CFETILMSheerIdApiConstant.SheerIdDocUpload,
                errorList: errorListResponse
              },
              trigger : {
                source: CFETILMSheerIdApiConstant.source
              }
            };
              this.sheeridApiService.sendSheerIdApiIntegrationData(
                sheerIdApiPayload).subscribe((response: any) => {
                console.log('SheerId API integration response:', response);
              }, (error: any) => {
                console.error('SheerId API integration error:', error);
              });
            }
      }
    }.bind(this, docUploadxhr);
  }
}
